/*
 *   File : manage-content.js
 *   Author : https://evoqins.com
 *   Description : manage content component
 *   Integrations : NA
 *   Version : 1.0.0
 */

import React, { useEffect, useState } from "react";
import { Tabs } from "../../Components/Navigation";
import { PrimaryButton } from "../../Components/Buttons";
import {
  Disclosure,
  Faq,
  Notification,
  PrivacyPolicy,
  TermsAndConditions,
} from "./Helper";
import { useDispatch } from "react-redux";
import { setPageTitle, setSearchEnabled } from "../../Redux/Ui/ui.slice";
import { useNavigate, useLocation } from "react-router-dom";

const TAB_DATA = [
  { id: 0, label: "notifications", name: "Notifications" },
  { id: 1, label: "faq", name: "FAQ" },
  { id: 2, label: "terms & Conditions", name: "Terms & Conditions" },
  { id: 3, label: "privacy Policy", name: "Privacy Policy" },
  { id: 4, label: "disclosure", name: "Disclosure" },
];

export default function ManageContent() {
  const navigate = useNavigate();
  const location = useLocation();
  const [curTab, setCurTab] = useState(0);

  // redux ui
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(setPageTitle(["Manage Content"]));
    dispatch(setSearchEnabled(false));
  }, [dispatch]);

  // Sync tab with route
  useEffect(() => {
    const path = location.pathname || "";

    // Map route prefixes -> tab index
    if (path.startsWith("/manage-content/notification")) {
      setCurTab(0);
      return;
    }
    if (path.startsWith("/manage-content/faq")) {
      setCurTab(1);
      return;
    }
    if (path.startsWith("/manage-content/terms")) {
      setCurTab(2);
      return;
    }
    if (path.startsWith("/manage-content/privacy")) {
      setCurTab(3);
      return;
    }
    if (path.startsWith("/manage-content/disclosure")) {
      setCurTab(4);
      return;
    }

    // fallback to default tab
    setCurTab(0);
  }, [location.pathname]);

  // handles navigation based on current tab (used by Add button)
  const navigator = () => {
    if (curTab === 0) return navigate("/manage-content/notification/add");
    if (curTab === 1) return navigate("/manage-content/faq/add");
    if (curTab === 2) return navigate("/manage-content/terms-conditions/edit");
    if (curTab === 3) return navigate("/manage-content/privacy-policy/edit");
    if (curTab === 4) return navigate("/manage-content/disclosure/edit");
  };

  return (
    <div className="row">
      <div className="col-12 pt-78">
        <div className="d-flex flex-column e-glass-card bg-transparent rounded-24 ">
          <div className="d-flex justify-content-between p-24">
            <Tabs
              data={TAB_DATA}
              defaultActive={curTab}
              onChange={(activeId) => {
                setCurTab(activeId);
              }}
            />
            <PrimaryButton
              ClassName="rounded-16 bg-oxford-blue lh-24 text-capitalize py-2 px-3 e-w-fit text-white w-220 fs-16 fw-400"
              name={`${curTab === 0 || curTab === 1 ? "Add " : "Edit "} ${
                TAB_DATA[curTab].label
              }`}
              onPress={navigator}
            />
          </div>
          {curTab === 0 && <Notification />}
          {curTab === 1 && <Faq />}
          {curTab === 2 && <TermsAndConditions />}
          {curTab === 3 && <PrivacyPolicy />}
          {curTab === 4 && <Disclosure />}
        </div>
      </div>
    </div>
  );
}
